<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="margin-right-small">
        <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha entrega desde">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
            Ingrese la fecha desde
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha entrega hasta">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
            Ingrese la fecha hasta
        </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
      <input matInput autocomplete="off" formControlName="AppointmentDate" [matDatepicker]="pickerAppointmentDate" placeholder="Fecha turno">
      <mat-datepicker-toggle matSuffix [for]="pickerAppointmentDate"></mat-datepicker-toggle>
      <mat-datepicker #pickerAppointmentDate></mat-datepicker>
      <mat-error *ngIf="f.AppointmentDate.errors && f.AppointmentDate.errors.required">
          Ingrese la fecha hasta
      </mat-error>
  </mat-form-field>
    <mat-form-field class="full-width">
        <input matInput autocomplete="off" formControlName="Protocol" placeholder="Protocolo">
    </mat-form-field>
    <mat-form-field class="full-width">
        <input type="text" #studyReportPhysician matInput placeholder="Médico informante" formControlName="StudyReportPhysician" [matAutocomplete]="autStudyReportPhysician">
        <mat-autocomplete #autStudyReportPhysician="matAutocomplete" [displayWith]="filterCompleteReferringPhysicians.displayFn">
            <mat-option *ngFor="let physician of filteredReferringPhysiciansOptions | async" [value]="physician">
                {{physician.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="medium-width">
        <input type="text" #referringPhysician matInput placeholder="Médico actuante" formControlName="ReferringPhysician" [matAutocomplete]="autReferringPhysician">
        <mat-autocomplete #autReferringPhysician="matAutocomplete" [displayWith]="filterCompleteStudyReportPhysicians.displayFn">
            <mat-option *ngFor="let physician of filteredStudyReportPhysiciansOptions | async" [value]="physician">
                {{physician.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

      <mat-form-field class="medium-width">
        <input type="text" #region matInput placeholder="Región" formControlName="StudyRegion" [matAutocomplete]="autStudyRegion">
        <mat-autocomplete #autStudyRegion="matAutocomplete" [displayWith]="filterCompleteStudyRegions.displayFn">
            <mat-option *ngFor="let region of filteredStudyRegionsOptions | async" [value]="region">
                {{region.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>


    <mat-form-field class="medium-width">
        <input type="text" #referringPhysician matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autService">
        <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
            <mat-option *ngFor="let service of filteredServicesOptions | async" [value]="service">
                {{ service.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="medium-width">
        <input type="text" #referringPhysician matInput placeholder="Centro" formControlName="Center" [matAutocomplete]="autCenter">
        <mat-autocomplete #autCenter="matAutocomplete" [displayWith]="filterCompleteCenters.displayFn">
            <mat-option *ngFor="let center of filteredCentersOptions | async" [value]="center">
                {{center.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <div class="full-width">
        <patient-autocomplete formControlName="Patient"></patient-autocomplete>
    </div>




    <mat-checkbox *ngIf="seeAllStudies" class="margin-right-small" formControlName="MyStudyReport">Solo mis informes</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="SeeToInform">A informar</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="SeeToCorrect">A corregir</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="SeeConfirmed">Confirmados</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="WithAdminControled">Con ctrl. admin.</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="ReAppointment">Recitados</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="OrderByPatient">Ordenar por paciente</mat-checkbox>
</form>
